export enum OrderStylesTestButtonEnum {
  CREATE_STYLE_BTN = 'create-style-btn',
  IMPORT_STYLE_FROM_ANOTHER_ORDER_BTN = 'import-style-from-another-order-btn',
}

export enum OrderStylesTestTooltipEnum {
  STYLES_LIMIT_TTP = 'styles-limit-ttp',
}
